import {API_ROOT} from "../../config";
import {RECEIVE_USER} from "../actionTypes";


function receiveUser(user) {
  return {
    type: RECEIVE_USER,
    user: user
  }
}


export function fetchUser() {
  return (dispatch, getState) => {
    const state = getState();
    if (state.auth.token) {
      return fetch(API_ROOT + '/rest-auth/user/', {
        headers: {
          'Authorization': 'Token ' + state.auth.token
        }
      }).then(
        response => {
          response.json().then(json => {
            dispatch(receiveUser(json))
          });
        },
        error => {
          console.error(error);
        }
      )
    }
  }
}




// WEBPACK FOOTER //
// ./src/state/actions/user.js